// src/services/addonService.js
// Service for fetching add-ons from the backend API using centralized HTTP client
import api from './http';

export async function fetchAddons() {
  try {
    const response = await api.get('/v1/addons');
    return Array.isArray(response.data.addons) ? response.data.addons : [];
  } catch (error) {
    console.error('Error fetching addons:', error);
    throw error;
  }
}

export async function fetchAddonsByCategory(category) {
  try {
    const response = await api.get(`/v1/addons/category/${category}`);
    return Array.isArray(response.data.addons) ? response.data.addons : [];
  } catch (error) {
    console.error('Error fetching addons by category:', error);
    throw error;
  }
}

export async function fetchAddonCategories() {
  try {
    const response = await api.get('/v1/addon-categories');
    return Array.isArray(response.data.categories) ? response.data.categories : [];
  } catch (error) {
    console.error('Error fetching addon categories:', error);
    throw error;
  }
}